import { render, staticRenderFns } from "./HospoitalContact.vue?vue&type=template&id=1642c4d6&scoped=true&"
import script from "./HospoitalContact.vue?vue&type=script&lang=js&"
export * from "./HospoitalContact.vue?vue&type=script&lang=js&"
import style0 from "./HospoitalContact.vue?vue&type=style&index=0&id=1642c4d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642c4d6",
  null
  
)

export default component.exports